import Service from './Service';


class FirmService extends Service {
  //
  /**
 * @type {string}
 */
  apiResource = "/firms";
}

export default new FirmService();
